import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { InputText } from "primereact/inputtext"
import { InputNumber } from 'primereact/inputnumber';
import { Button } from "primereact/button"
import commonStyles from "../../common.module.css"
import api from "../../../api"
import backConfirmation from "../../../function/backConfirmation"
import { queryKeys } from "../../../client"
import { useQueryClient } from "react-query"
import { ColorPicker } from "primereact/colorpicker"
import { TASK_TAGS_STYLES_ID } from "../../../constants";

export default function EnumTaskTagForm() {
  const { uuid } = useParams()
  const back = () => window.history.back()
  const queryClient = useQueryClient()

  const [name, setName] = useState("")
  const handleNameChange = (e) => setName(e.target.value)

  const [abbr, setAbbr] = useState("")
  const handleAbbrChange = (e) => setAbbr(e.target.value)

  const [position, setPosition] = useState("")
  const handlePositionChange = (e) => setPosition(e.value)

  const [color, setColor] = useState("#FFFFFF")
  const handleColorChange = (e) => setColor(`#${e.target.value}`)

  const create = () => api
    .put("/task-tags", { name, abbr, position, color })
    .then(() => {
      queryClient.invalidateQueries(queryKeys.TASK_TAGS, { refetchInactive: true })
      const stylesElement = document.getElementById(TASK_TAGS_STYLES_ID)
      if (stylesElement) {
        stylesElement.remove()
      }
      back()
    })

  const update = () => api
    .post(`/task-tags/${uuid}`, { uuid, name, abbr, position, color })
    .then(() => {
      queryClient.invalidateQueries(queryKeys.TASK_TAGS, { refetchInactive: true })
      const stylesElement = document.getElementById(TASK_TAGS_STYLES_ID)
      if (stylesElement) {
        stylesElement.remove()
      }
      back()
    })

  const handleFormSubmit = (e) => {
    e.preventDefault()
    queryClient.invalidateQueries(queryKeys.TASK_TAGS, { refetchInactive: true })
    uuid ? update() : create()
  }

  useEffect(() => {
    if (uuid) {
      api.get(`/task-tags/${uuid}`)
        .then(({ data }) => {
          setName(data.data.name)
          setAbbr(data.data.abbr)
          setPosition(data.data.position)
          setColor(data.data.color || "#FFFFFF")
        })
    }
  }, [uuid])

  return (
    <form className={"col-12 md:col-6"} onSubmit={handleFormSubmit}>
      <div className={"p-fluid"}>
        <div className={"field"}>
          <label className={commonStyles.labelRequired}>Název:</label>
          <InputText required={true} value={name} onChange={handleNameChange} />
        </div>
        <div className={"field"}>
          <label className={commonStyles.labelRequired}>Zkratka:</label>
          <InputText required={true} value={abbr} onChange={handleAbbrChange} minLength={1}
            maxLength={3} />
        </div>
        <div className={"field"}>
          <label className={commonStyles.labelRequired}>Pozice:</label>
          <InputNumber required={true} value={position} onValueChange={handlePositionChange} min={1} max={999} useGrouping={false} />
        </div>
        <div className={"field"}>
          <label className={commonStyles.labelRequired}>Barva:</label>
          <div>
            <ColorPicker value={color} onChange={handleColorChange} />
          </div>
        </div>
      </div>

      <div className={"flex"}>
        <Button type={"button"} label={"Zpět"} className={"p-button-warning m-1"}
          onClick={backConfirmation} />
        <div className={"ml-auto"}>
          <Button type={"submit"} label={"Uložit"} className={"m-1"} />
        </div>
      </div>
    </form>
  )
}
